import React, {useEffect, useMemo, useState} from "react";
import CustomDialog from "../../components/general/CustomDialog";
import CustomButton from "../../components/general/CustomButton";
import {useTranslation} from "react-i18next";
import useInputValue from "../../hooks/useInputValue";
import CustomInput from "../../components/general/CustomInput";
import getConstrains from "../../utils/validationConstraints";
import useValidation from "../../hooks/useValidation";
import CustomSelectIcons from "../../components/general/CustomSelectIcons";
import {DepartmentInterface} from "../../services/interface/DepartmentInterface";
import {useCreateDepartment, useEditDepartment} from "../../services/department/apiDepartments";
import {showToast} from "../../components/general/CustomToast";

interface Props {
    department?: DepartmentInterface;
    title: string;
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
export default function DialogCreateDepartment({department, title, open, setOpen}: Props) {
    const {t} = useTranslation("global") as { t: (key: string) => string }

    const {
        mutate: createDepartment,
        isPending: isLoadingCreate,
        data: successCreate
    } = useCreateDepartment();

    const {
        mutate: editDepartment,
        isPending: isLoadingEdit,
        data: successEdit
    } = useEditDepartment();

    const [errorValidation, setErrorValidation]: any = useState(null);
    const validationSchema = useMemo(
        () => getConstrains(['name']),
        []
    );
    const validation = useValidation(validationSchema);

    const name = useInputValue(department?.name ? department.name : "")
    const description = useInputValue(department?.description ? department.description : "")
    const [icon, setIcon] = useState<string | undefined>(department?.icon ? department.icon : undefined)

    useEffect(() => {
        if (successCreate) {
            showToast(t('success-create-department'), 'success')
            setOpen(false);
        }
    }, [successCreate]);

    useEffect(() => {
        if (successEdit) {
            showToast(t('success-edit-department'), 'success')
            setOpen(false);
        }
    }, [successEdit]);

    return (
        <>
            <CustomDialog
                size={'md'}
                body={
                    <div>
                        <div className={'flex flex-col gap-5'}>
                            <CustomInput
                                type={'letters'}
                                labelFixel={true}
                                label={t('name')}
                                error={errorValidation?.name}
                                {...name}
                            />
                            <CustomInput
                                type={'letters'}
                                labelFixel={true}
                                label={t('description')}
                                {...description}
                            />
                            <CustomSelectIcons
                                label={t('icon')}
                                value={icon}
                                setValue={setIcon}
                            />
                        </div>
                        <div className={'flex justify-end mt-3'}>
                            <CustomButton
                                text={t('save')}
                                disabled={isLoadingCreate || isLoadingEdit}
                                loading={isLoadingCreate || isLoadingEdit}
                                onClick={() => {
                                    let data: DepartmentInterface
                                    if (title === t('create-department')) {
                                        data = {
                                            name: name.value,
                                            icon: icon,
                                            description: description.value,
                                        }
                                        const errors = validation(data);
                                        if (errors !== null && Object.keys(errors).length) {
                                            setErrorValidation(errors)
                                            showToast(
                                                'Campos obligatorios por llenar (*)',
                                                'warning-info'
                                            );
                                        } else {
                                            setErrorValidation(null);
                                            createDepartment(data)
                                        }
                                    } else {
                                        data = {
                                            ...department,
                                            name: name.value,
                                            icon: icon,
                                            description: description.value,
                                        }
                                        const errors = validation(data);
                                        if (errors !== null && Object.keys(errors).length) {
                                            setErrorValidation(errors)
                                            showToast(
                                                'Campos obligatorios por llenar (*)',
                                                'warning-info'
                                            );
                                        } else {
                                            setErrorValidation(null);
                                            editDepartment(data)
                                        }
                                    }
                                }}
                            />
                        </div>
                    </div>
                }
                {...{title, open, setOpen}}
            />
        </>
    )
}
